import React from 'react';
import { Modal, Button, Form, Spinner, Row, Col } from 'react-bootstrap';
import { UserModel } from '../../../models/UserModel';

interface CommissionModalProps {
  show: boolean;
  localUser: UserModel;
  commissionPct: number;
  description: string;
  validFrom: string;
  validUntil: string;
  submitting: boolean;
  onHide: () => void;
  onCommissionPctChange: (value: number) => void;
  onDescriptionChange: (value: string) => void;
  onValidFromChange: (value: string) => void;
  onValidUntilChange: (value: string) => void;
  onSave: () => void;
}

const CommissionModal: React.FC<CommissionModalProps> = ({
  show,
  localUser,
  commissionPct,
  description,
  validFrom,
  validUntil,
  submitting,
  onHide,
  onCommissionPctChange,
  onDescriptionChange,
  onValidFromChange,
  onValidUntilChange,
  onSave,
}) => {
  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      backdrop="static" 
      centered 
      size="lg" 
      style={{ zIndex: 12000 }}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Modifier la commission de {localUser.firstname} {localUser.name}
        </Modal.Title>
      </Modal.Header>
      <Form>
        <Modal.Body>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Pourcentage de commission *</Form.Label>
                <Form.Control
                  type="number"
                  min={0}
                  max={100}
                  step={0.01}
                  value={commissionPct}
                  onChange={e => onCommissionPctChange(Number(e.target.value))}
                  placeholder="0.00"
                  required
                />
                <Form.Text className="text-muted">
                  {commissionPct === 0 ? '0% désactivera la commission' : 'Entre 0 et 100%'}
                </Form.Text>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  type="text"
                  maxLength={255}
                  value={description}
                  onChange={e => onDescriptionChange(e.target.value)}
                  placeholder="Description optionnelle"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Date de début</Form.Label>
                <Form.Control
                  type="date"
                  value={validFrom}
                  onChange={e => onValidFromChange(e.target.value)}
                />
                <Form.Text className="text-muted">
                  Optionnel - Si vide, effective immédiatement
                </Form.Text>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Date de fin</Form.Label>
                <Form.Control
                  type="date"
                  value={validUntil}
                  onChange={e => onValidUntilChange(e.target.value)}
                  min={validFrom || undefined}
                />
                <Form.Text className="text-muted">
                  Optionnel - Si vide, pas de date d'expiration
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button 
            variant="outline-secondary" 
            onClick={onHide} 
            disabled={submitting}
          >
            Annuler
          </Button>
          <Button
            variant="primary"
            onClick={onSave}
            disabled={submitting || commissionPct < 0 || commissionPct > 100}
          >
            {submitting ? (
              <>
                <Spinner as="span" animation="border" size="sm" /> Enregistrement…
              </>
            ) : (
              'Enregistrer'
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CommissionModal;